import { render, staticRenderFns } from "./menuPrincipalComponent.vue?vue&type=template&id=7e8cb1b1&scoped=true&lang=html&"
import script from "./menuPrincipalComponent.vue?vue&type=script&lang=js&"
export * from "./menuPrincipalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8cb1b1",
  null
  
)

export default component.exports